import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

//styles
import './style.scss';

//antd component
import { Button } from 'antd';

//assets
import CustomIcons from 'components/CustomIcons';

function FinalScreen({ continueAction, title, loading, successful, content, children, className }) {
  const childClassName = classNames('absence-final-screen', className);

  return (
    <div className={childClassName}>
      <div className="absence-final-screen__icon">
        <CustomIcons type="sick-leave" />
      </div>
      <div className="absence-final-screen__content">
        {title && <h3 className="content-title">{title}</h3>}
        
        {(content || children) && (
          <div
            className="content-text"
            dangerouslySetInnerHTML={{ __html: content || children }}
          />
        )}
      </div>
    
      {!!continueAction && (
        <Button loading={loading} disabled={loading} onClick={continueAction} className="absence-final-screen__btn">
          Continuer
        </Button>
      )}
    </div>
  );
}

FinalScreen.defaultProps = {
  title: `Votre demande a été transmise`,
  content: `Vous serez informé de la décision prise par l’établissement
  scolaire sur votre application Schoolinked et par e-mail dans les
  meilleurs délais`,
};

FinalScreen.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string,
  continueAction: PropTypes.func,
};

export default memo(FinalScreen);
